<template>
	<ActivitySavedSearchNewOpportunityDetail
		v-if="activityDetail.activity.notificationTopic === NotificationTopic.SavedSearchNewOpportunity"
		:activity-detail="activityDetail"
		:loading="loading"
		:load-error="loadError"
		:show-header="showHeader"
		@view-search="$emit('view-search', $event)"
	/>
	<ActivityCommentDetailCard
		v-else-if="activityDetail.activity.notificationTopic === NotificationTopic.CommentedOpportunity"
		:activity-detail="activityDetail"
		:loading="loading"
		:load-error="loadError"
		:show-header="showHeader"
		@view-project="$emit('view-project', $event)"
	/>
	<ActivityReactionDetailCard
		v-else-if="reactionTopics.includes(activityDetail.activity.notificationTopic)"
		:activity-detail="activityDetail"
		:loading="loading"
		:load-error="loadError"
		:show-header="showHeader"
		@view-project="$emit('view-project', $event)"
	/>
	<ActivityTargetCreatedDetailCard
		v-else-if="activityDetail.activity.notificationTopic === NotificationTopic.TargetCreated"
		:activity-detail="activityDetail"
		:loading="loading"
		:load-error="loadError"
		:show-header="showHeader"
		@view-project="$emit('view-project', $event)"
	/>
</template>

<script setup lang="ts">
import ActivityCommentDetailCard from "@/components/activity/ActivityCommentDetailCard.vue"
import ActivityReactionDetailCard from "@/components/activity/ActivityReactionDetailCard.vue"
import ActivitySavedSearchNewOpportunityDetail from "@/components/activity/ActivitySavedSearchNewOpportunityDetail.vue"
import ActivityTargetCreatedDetailCard from "@/components/activity/ActivityTargetCreatedDetailCard.vue"
import { NotificationTopic } from "@/graphql"
import type { ActivityDetail } from "@/types/activity"

const reactionTopics: NotificationTopic[] = [NotificationTopic.LikedOpportunity, NotificationTopic.DislikedOpportunity]

withDefaults(
	defineProps<{
		activityDetail: ActivityDetail
		loading?: boolean
		loadError?: boolean
		showHeader?: boolean
	}>(),
	{
		loading: false,
		loadError: false,
		showHeader: true,
	}
)

defineEmits<{
	"view-search": [savedSearchId: string]
	"view-project": [projectId: string]
}>()
</script>
